import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  ViewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TextOverflowYDirective } from '@shared/directives/text-overflow-y.directive';

@Component({
  selector: 'app-toc',
  imports: [
    TranslateModule,
    MatTooltip,
    TextOverflowYDirective,
  ],
  templateUrl: './toc.component.html',
  styleUrl: './toc.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TocComponent implements AfterViewChecked {

  useOnlyFullBody = false;

  hasHtml = false;
  tocContent: any[] = [];
  parentElement!: HTMLElement;
  hasTwoColumns = false;
  tocWidth: number = 0;
  tocContentLength: number = 0;
  cd: ChangeDetectorRef = inject(ChangeDetectorRef);
  elRef: ElementRef = inject(ElementRef);
  @ViewChild('tocRootElement') tocRootElement!: ElementRef;


  ngAfterViewChecked() {
    setTimeout(() => {
      const parentRef = this.elRef?.nativeElement?.parentElement;
      const content = this.useOnlyFullBody
        ? parentRef?.querySelectorAll('.ck-content.full-body')
        : parentRef?.querySelectorAll('.ck-content');


      if (!this.hasHtml
        && !!parentRef
        && content?.length) {
        this.parentElement = parentRef;
        this.hasHtml = true;
        this.generate(content);
      }

    }, 200);
  }

  tocWidthHandler() {
    if (!this.tocRootElement) return;

    this.tocWidth = this.tocRootElement.nativeElement.offsetWidth;
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.target === this.tocRootElement.nativeElement) {
          this.tocWidth = entry.contentRect.width;
          this.hasTwoColumns = this.tocWidth > 500 && this.tocContentLength > 8;
          this.cd.markForCheck();
        }
      }
    });
    resizeObserver.observe(this.tocRootElement.nativeElement);
  }

  generate(content: HTMLElement[]) {
    let index = 0;
    const toc: any[] = [];
    content.forEach((editorBlock: HTMLElement) => {
      const headers = editorBlock.querySelectorAll('h1, h2');
      let currentHeader: any = {};

      headers.forEach(header => {
        header.setAttribute('id', `header-${index}`);
        const isH1 = header.tagName === 'H1';

        const result = {
          id: `header-${index}`,
          text: header.textContent,
          children: [],
        };

        if (isH1) {
          currentHeader = result;
          toc.push(currentHeader);
        } else {
          if (!currentHeader || !Object.keys(currentHeader).length) {
            currentHeader = result;
          }
          currentHeader.children.push(result);
        }
        this.tocContentLength = index;
        index++;
      });
    });

    this.tocContent = toc;
    this.cd.detectChanges();
    if (this.tocContent.length) {
      this.tocWidthHandler();
    }
  }

  scrollToHeader(id: string) {
    const header = this.parentElement.querySelector(`#${id}`);
    if (header) {
      header.scrollIntoView({ behavior: 'smooth' });
    }
  }


}
